<script setup>
import { ref, computed, onMounted, defineAsyncComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
/***/
import { useApplicationStore } from '@stores/application';
/***/
import { useAuthUser } from '@compositions/Auth';

const Layout = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Layouts/Authenticated'));
const CustomizeApplicationForm = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Admin/Application/CustomizeForm'));
const Loader = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/UI/Loader'));

const router = useRouter();
const { t } = useI18n();

const applicationStore = useApplicationStore();

const { authUser, authUserHasPermission, authUserIsSuperAdmin } = useAuthUser({});

const meApplication = computed(() => applicationStore.getMe);
const currentApplication = computed(() => applicationStore.getCurrent);
const loadingApplication = ref(false);
const errorLoadingApplication = ref(false);


// Chargement de l'application de l'utilisateur
const loadApplication = (() => {
    loadingApplication.value = true;
    // Chargement de l'application
    applicationStore.loadMe().then(() => {

    }).catch(() => {
        errorLoadingApplication.value = true;
    }).finally(() => {
        setTimeout(() => {
            loadingApplication.value = false;
        });
    });
});

// Vrai si l'utilisateur peut gérer les templates des lignes graphiques
const canManageGraphicalLineTemplates = computed(() => authUserHasPermission('consult graphical line templates'));

onMounted(() => {
    const canConsult = authUserHasPermission('consult self application');
    if(! canConsult) {
        router.push({
            name: 'error',
            params: {
                statusCode: 404
            }
        });
    } else {
        loadApplication();

        document.title = t('page.admin.customizeApplication.title') + ' - ' + currentApplication.value.name;
    }
});

</script>

<template>
    <layout>
        <loader v-if="loadingApplication"></loader>
        <template v-else>
            <div class="content_header">
                <div class="content-header_title">
                    <h1 class="first-title">{{ $t('page.admin.customizeApplication.title') }}</h1>
                    <p>{{ $t('page.admin.customizeApplication.description') }}</p>
                </div>
                <div
                    v-if="canManageGraphicalLineTemplates"
                    class="content-header_btn"
                >
                    <router-link
                        :to="{ name: 'admin.graphical-line-templates.index' }"
                        :title="$t('page.admin.customizeApplication.manageGraphicalLineTemplatesButton.altLabel')"
                        class="button button-primary-outline"
                    >
                        <span>{{ $t('page.admin.customizeApplication.manageGraphicalLineTemplatesButton.label') }}</span>
                    </router-link>
                </div>
            </div>
            <p v-if="errorLoadingApplication" class="generic-message generic-message-error">
                {{ $t('page.admin.customizeApplication.loadingError') }}
            </p>
            <customize-application-form v-else-if="meApplication"></customize-application-form>
        </template>
    </layout>
</template>
